import { useUserStore } from '../stores/UserStore';
import { RestService } from './RestService';

export const isLogin = () => !!useUserStore.getState().UUID;

export const socialLogin = async (data: any) => {
  return RestService.post('/auth/login', data).then((user: any) => {
    useUserStore.setState({
      UUID: user.data.uuid,
      UNAME: user.data.name,
      UEMAIL: user.data.email,
      UMOBILE: user.data.mobile,
      UABOUT: user.data.about,
      UDOB: user.data.dob,
      TOKEN: user.data.token
    });
    return user.data;
  });
};

export const deleteAccount = (data: any) => {
  return RestService.post('/auth/delete-account', data);
};

export const storePushToken = (data: any) => {
  return RestService.post('/push', data);
};
